export default __webpack_public_path__ + "static/media/services (2).db29f938.jpg";